export const FormField = ({
  style,
  label,
  children,
  col = false,
}: {
  style?: string;
  label: string;
  children: React.ReactNode;
  col?: boolean;
}) => (
  <div
    className={`flex mb-30 ${
      col
        ? "flex-col items-stretch gap-10"
        : "flex-row items-center gap-50"
    }`}
  >
    <h3
      className={`text-dark-grey font-bold ${style ? style : "text-sm"} ${
        col ? "w-full" : "w-1/4"
      }`}
    >
      {label}
    </h3>
    <div
      className={`flex flex-col items-start ${col ? "w-full" : "w-3/4"}`}
    >
      {children}
    </div>
  </div>
);
